export enum FileFormat {
  PDF = '.pdf',
  JPG = '.jpg',
  PNG = '.png',
  P12 = '.p12',
  XLSX = '.xlsx',
}
